export default __webpack_public_path__ + "static/favicon-d6afaf76a17411b6742cf89c95e72bf2.ico";